import React from 'react';
import { Navigate, Outlet, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, FolderOpen, FileText, MessageSquare, LogOut, Tag } from 'lucide-react';

const AdminLayout = () => {
  const location = useLocation();
  const token = localStorage.getItem('admin_token');

  if (!token) {
    return <Navigate to="/admin/login" />;
  }

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    window.location.href = '/admin/login';
  };

  const navItems = [
    { name: 'Dashboard', path: '/admin/dashboard', icon: LayoutDashboard },
    { name: 'Proyectos', path: '/admin/projects', icon: FolderOpen },
    { name: 'Blog', path: '/admin/blog', icon: FileText },
    { name: 'Mensajes', path: '/admin/messages', icon: MessageSquare },
    { name: 'Categorías', path: '/admin/categories', icon: Tag },
  ];

  return (
    <div className="min-h-screen bg-offwhite" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="fixed left-0 top-0 bottom-0 w-64 bg-ink text-paper p-6 overflow-y-auto" data-testid="admin-sidebar">
        <div className="mb-12">
          <h1 className="text-2xl font-bold tracking-tight">Admin Panel</h1>
          <p className="text-xs font-sans tracking-widest uppercase text-paper/60 mt-2">Portfolio</p>
        </div>

        <nav className="space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`admin-nav-${item.name.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 text-sm font-sans tracking-wide transition-colors ${
                  isActive ? 'bg-editorial text-paper' : 'text-paper/70 hover:bg-paper/10'
                }`}
              >
                <Icon className="w-5 h-5" />
                {item.name}
              </Link>
            );
          })}
        </nav>

        <button
          onClick={handleLogout}
          data-testid="admin-logout-button"
          className="flex items-center gap-3 px-4 py-3 text-sm font-sans tracking-wide text-paper/70 hover:bg-paper/10 transition-colors w-full mt-8"
        >
          <LogOut className="w-5 h-5" />
          Cerrar Sesión
        </button>
      </aside>

      {/* Main Content */}
      <main className="ml-64 p-8" data-testid="admin-main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;